import script from "./DevCertRegistrationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DevCertRegistrationPage.vue?vue&type=script&setup=true&lang=js"

import "./DevCertRegistrationPage.vue?vue&type=style&index=0&id=794d39a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-794d39a8"]])

export default __exports__